import React from 'react';
import { 
  DashboardIcon, 
  RestaurantIcon, 
  DeliveryIcon, 
  AccountIcon,
  ClipboardListIcon
} from './icons';

export type SuperAdminTab = 'dashboard' | 'restaurants' | 'drivers' | 'payments' | 'profile';

interface SuperAdminBottomNavProps {
  activeTab: SuperAdminTab;
  onTabChange: (tab: SuperAdminTab) => void;
}

const SuperAdminBottomNav: React.FC<SuperAdminBottomNavProps> = ({ activeTab, onTabChange }) => {
  const tabs: { id: SuperAdminTab; label: string; icon: any }[] = [
    { id: 'dashboard', label: 'Accueil', icon: DashboardIcon },
    { id: 'restaurants', label: 'Restos', icon: RestaurantIcon },
    { id: 'drivers', label: 'Livreurs', icon: DeliveryIcon },
    { id: 'payments', label: 'Paiements', icon: ClipboardListIcon },
    { id: 'profile', label: 'Profil', icon: AccountIcon },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 px-2 py-2 flex justify-around items-center z-50 pb-safe shadow-[0_-4px_20px_0_rgba(0,0,0,0.05)]">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex flex-col items-center justify-center py-1 px-3 rounded-2xl transition-all duration-300 ${
              isActive 
                ? 'text-red-600 bg-red-50' 
                : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            <Icon className={`w-6 h-6 ${isActive ? 'scale-110' : 'scale-100'} transition-transform duration-300`} />
            <span className={`text-[10px] font-bold mt-1 ${isActive ? 'opacity-100' : 'opacity-70'}`}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default SuperAdminBottomNav;
